"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireWildcard(require("prop-types"));

var _cardChildComponents = require("./card-child-components");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BaseCardComponent = function BaseCardComponent(_ref) {
  var selected = _ref.selected,
      hideHeader = _ref.hideHeader,
      title = _ref.title,
      subTitle = _ref.subTitle,
      bodyProps = _ref.bodyProps,
      hideFooter = _ref.hideFooter,
      footerProps = _ref.footerProps;
  return _react.default.createElement("div", {
    className: "base-card-component base-card-component--".concat(selected)
  }, _react.default.createElement(_cardChildComponents.CardHeader, {
    hideHeader: hideHeader,
    title: title,
    subTitle: subTitle
  }), _react.default.createElement(_cardChildComponents.CardBody, {
    bodyProps: bodyProps
  }), _react.default.createElement(_cardChildComponents.CardFooter, {
    hideFooter: hideFooter,
    footerProps: footerProps
  }));
};

BaseCardComponent.propTypes = {
  selected: _propTypes.string,
  hideHeader: _propTypes.bool,
  title: _propTypes.string,
  subTitle: _propTypes.string,
  bodyProps: _propTypes.default.objectOf(_propTypes.default.object),
  hideFooter: _propTypes.bool,
  footerProps: _propTypes.default.objectOf(_propTypes.default.object)
};
BaseCardComponent.defaultProps = {
  selected: '',
  hideHeader: true,
  title: '',
  subTitle: '',
  bodyProps: {},
  hideFooter: true,
  footerProps: {}
};
var _default = BaseCardComponent;
exports.default = _default;
